<template lang="pug">
  .container.grid-lg.py-2
    form.list-filters(@submit.prevent='listar')
      .columns.align-end
        .column.col-2
          .form-group
            small {{ 'doc_modelo.id' | tModel }}
            int.form-input.input-sm(v-model="q.id_eq")
        .column.col-2
          .form-group
            small {{ 'doc_modelo.tipo' | tModel }}
            select.form-select.select-sm(v-model="q.tipo_eq")
              option(:value="null")
              option(v-for="label, value in tipos" :value="value") {{ label }}
        .column
          .form-group
            small {{ 'doc_modelo.descricao' | tModel }}
            input.form-input.input-sm(v-model="q.descricao_cont")
        .column.col-auto
          .form-group
            label.form-checkbox
              input(type="checkbox" v-model="apenasAtivos")
              i.form-icon
              | Apenas ativos
        .column.col-auto
          button.btn.btn-action.s-circle.btn-sm
            i.fa.fa-filter
        .column.col-auto
          doc-tipos-dropdown(@selected="onAddDocModelo")
            .btn.btn-action.s-circle.btn-sm
              i.icon.icon-plus
    load-manager(:status='status')
      list-manager(:status='status', :count='list.length')
        table.table.table-striped
          thead
            tr
              th \#{{ 'doc_modelo.id' | tModel }}
              th {{ 'doc_modelo.tipo' | tModel }}
              th {{ 'doc_modelo.titulo' | tModel }}
              th {{ 'doc_modelo.descricao' | tModel }}
              th(width="1")
          tbody
            tr(v-for="row in list")
              td {{ row.id }}
              td {{ row | enums('doc.tipo') }}
              td {{ row.titulo }}
              td {{ row.descricao }}
              td.text-right.no-(width="1")
                .dropdown.dropdown-right
                  a.btn.btn-link.dropdown-toggle(href='#' tabindex="0")
                    i.fa.fa-cog.fa-lg
                  ul.menu
                    li.menu-item.text-primary.text-left
                      router-link(
                        :to="{ name: 'sistema.docModelos.edit.info', params: { id: row.id } }"
                        v-acl:allowed.admin.assuntos.update
                      )
                        btn-content(name='edit')
                    li.menu-item.text-left
                      a(:href='row.url' target='_blank')
                        btn-content(name='print')
        .float-right
          paginator(:page='page', :pages='pages', @prev-page='prevPage', @next-page='nextPage'  color='#599940')
</template>

<script>
export default {
  vuex: {
    'sistema/docModelos': {
      state: ['list', 'status', 'page', 'pages', 'query'],
      getters: ['loading'],
      mutations: ['setQuery', 'setPage'],
      actions: ['fetchList', 'prevPage', 'nextPage'],
    },
  },
  computed: {
    tipos() {
      return this.$i18n.t('enums.db.enum_doc_tipo')
    },
  },
  data() {
    return { q: {}, apenasAtivos: true }
  },
  methods: {
    onAddDocModelo(docTipo) {
      this.$router.push({
        name: 'sistema.docModelos.new.info',
        params: { docTipo },
      })
    },
    listar() {
      const query = { ...this.q }
      if (this.apenasAtivos) query.ativo_eq = true
      else delete query.ativo_eq
      this.setQuery(query)
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
